import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function CapHatDigitizing() {

    const capSteps = [
        { number: "01", title: "Submit Your Design", description: "Send us your logo or artwork in JPG, PNG, PDF, or AI format.", icon: "📤" },
        { number: "02", title: "Cap-Specific Digitizing", description: "We adjust stitch angles, density, and sequencing for cap embroidery.", icon: "⚡" },
        { number: "03", title: "Quality Optimization", description: "We test and refine the design to ensure smooth stitching on hats.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery files in DST, PES, JEF, and other formats.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Cap & Hat Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Get expert cap and hat embroidery digitizing services in Los Angeles, CA. Perfect stitch files for hats and caps. Fast turnaround. Order now!" />
                <meta name="keywords" content="cap embroidery digitizing, hat digitizing services, cap logo digitizing, hat embroidery digitizing, Los Angeles cap digitizing, embroidery digitizing near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Cap / Hat Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Cap / Hat Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/caphat1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Structured for Perfect Front Panels</span>
                                <h3 className="case-study-title">Professional Cap & Hat Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide specialized cap and hat embroidery digitizing services in Los Angeles, California, designed to deliver flawless embroidery results on curved surfaces. Digitizing for caps requires a unique approach compared to flat embroidery, as factors like stitch direction, push and pull compensation, and design placement play a crucial role in achieving clean and professional results.
                                </p>
                                <p className="case-study-description">
                                    Our expert digitizers carefully adjust every design to ensure it runs smoothly on cap embroidery machines without distortion or thread breaks. Whether you need logos for snapbacks, fitted caps, or promotional hats, our cap embroidery digitizing services ensure sharp detail, proper alignment, and consistent stitching. If you're searching for reliable hat digitizing services near you in Los Angeles, Grand Indigo Embroidery offers precision-driven solutions tailored for cap embroidery.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Engineered for Cap Machines</span>
                                <h3 className="case-study-title">Custom Hat Logo Digitizing for Perfect Embroidery Results</h3>
                                <p className="case-study-description">
                                    We specialize in custom cap logo digitizing services for businesses, brands, and embroidery shops that require high-quality results. From bold front logos to side placements and detailed designs, we optimize every file specifically for cap embroidery to ensure maximum visual impact.
                                </p>
                                <p className="case-study-description">
                                    Our team works with all types of embroidery styles, including flat and 3D puff embroidery for hats. Each design is carefully digitized to maintain shape, depth, and clarity, even on structured caps. Businesses across Los Angeles trust us for fast turnaround, reliable service, and consistent quality. Whether you want to order cap embroidery digitizing online or work with a local expert, Grand Indigo Embroidery ensures your hat designs are production-ready and professionally executed.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/caphat2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={capSteps} />

            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is cap embroidery digitizing?"
                                    answer="Cap embroidery digitizing is the process of converting a logo into a stitch file specifically optimized for embroidery on hats and caps."
                                />

                                <FaqItem
                                    question="Do you offer cap digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides expert cap and hat digitizing services in Los Angeles, California, for local and online clients."
                                />

                                <FaqItem
                                    question="Why is cap digitizing different from regular embroidery digitizing?"
                                    answer="Cap digitizing requires special adjustments for curved surfaces, including stitch direction and compensation to avoid distortion."
                                />

                                <FaqItem
                                    question="Can I order cap logo digitizing online?"
                                    answer="Yes, you can easily submit your design and order cap embroidery digitizing online with fast turnaround."
                                />

                                <FaqItem
                                    question="What types of hats can you digitize designs for?"
                                    answer="We digitize designs for snapbacks, fitted caps, trucker hats, beanies, and more."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
